/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Erp_Export_ErrorInputs */



/**
* | output |
* | --- |
* | "The ERP export failed. No file was created." |
*
* @param {Partner_Erp_Export_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_erp_export_error = /** @type {((inputs?: Partner_Erp_Export_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Erp_Export_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der ERP-Export ist fehlgeschlagen. Es wurde keine Datei erstellt.")
	return /** @type {LocalizedString} */ ("The ERP export failed. No file was created.")
});